import auth from "./middleware/auth";
import companyRoutes from "./companies";
import employeeRoutes from "./employees";
import vehicleRoutes from "./vehicles";

const RouterComponent = {
  render(h) {
    return h("router-view");
  },
};

export default [
  {
    path: "/users",
    name: "Users",
    component: require("../views/Users").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: require("../views/Notifications").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: require("../views/Settings").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: "/companies",
    component: RouterComponent,
    children: companyRoutes,
  },
  {
    path: "/employees",
    component: RouterComponent,
    children: employeeRoutes,
  },
  {
    path: "/vehicles",
    component: RouterComponent,
    children: vehicleRoutes,
  },
];
